(function() {

  'use strict';


  async function _getCart() {
    const r = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
    return r.json();
  }

  async function _cartAdd(variantId, qty) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    });
    if (!r.ok) throw new Error('Add failed');
    return r.json();
  }

  async function _cartChange(lineKey, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    });
    if (!r.ok) throw new Error('Change failed');
    return r.json();
  }

  

  let _drawerObserver = null;

  function _attachDrawerObserver() {
    if (_drawerObserver) {
      _drawerObserver.disconnect();
      _drawerObserver = null;
    }

    const drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;

    _drawerObserver = new MutationObserver(() => {
      clearTimeout(window._bbSyncTimer);
      window._bbSyncTimer = setTimeout(async () => {
        try {
          const cart = await _getCart();
          document.querySelectorAll('.atc-qty-wrapper[data-bb-init]').forEach(w => {
            const vid = String(w.dataset.variantId || '');
            const it  = cart.items.find(i => String(i.variant_id) === vid);
            if (it && it.quantity > 0) _showQtyBox(w, it.quantity);
            else                       _showAtcBtn(w);
          });
        } catch(_) {}
      }, 400);
    });

    _drawerObserver.observe(drawerEl, { childList: true, subtree: true });
  }


  async function _refreshDrawer() {
    try {
    
      const res  = await fetch('/cart?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store' });
      const data = await res.json();

      if (data['cart-drawer']) {
        const parsed   = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        const drawerEl = document.querySelector('cart-drawer');

        if (drawerEl) {
          const newDrawer = parsed.querySelector('cart-drawer');
          if (newDrawer) {
         
            drawerEl.replaceWith(newDrawer);

         
            _attachDrawerObserver();
          } else {
           
            for (const sel of ['cart-drawer-items', '.js-contents']) {
              const o = drawerEl.querySelector(sel);
              const n = parsed.querySelector(sel);
              if (o && n) { o.replaceWith(n.cloneNode(true)); break; }
            }
            for (const sel of ['.cart-drawer__footer', '.drawer__footer']) {
              const o = drawerEl.querySelector(sel);
              const n = parsed.querySelector(sel);
              if (o && n) { o.replaceWith(n.cloneNode(true)); break; }
            }
          }
        }
      }

     if (data['cart-icon-bubble']) {
  const parsed     = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
  const newBubble  = parsed.querySelector('.cart-count-bubble');
  const existingBubbles = document.querySelectorAll('.cart-count-bubble');

  if (existingBubbles.length > 0) {
    existingBubbles.forEach(b => {
      if (newBubble) {
        b.innerHTML = newBubble.innerHTML;
        b.removeAttribute('hidden');
        b.style.display = '';
      } else {
        b.innerHTML = '';
        b.setAttribute('hidden', '');
        b.style.display = 'none';
      }
    });
  } else if (newBubble) {
    const cartIcon =
      document.querySelector('.header__icon--cart') ||
      document.querySelector('a[href="/cart"]');
    if (cartIcon) cartIcon.insertAdjacentHTML('beforeend', newBubble.outerHTML);
  }

   new Swiper(".cart-collection-swiper", {
      slidesPerView: 1.2,
      spaceBetween: 10,
      loop:true,
      navigation: {
        nextEl: ".swiper-button-next1",
        prevEl: ".swiper-button-prev1",
      },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    }); 
}


    } catch(e) {
      console.error('[buy-btn] drawer refresh failed', e);
    }
  }

 

  async function _openDrawer() {
    const drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;
    if (typeof drawerEl.open === 'function') {
      drawerEl.open();
    } else {
      const dialog = drawerEl.querySelector('#CartDrawer');
      dialog?.classList.add('is-open', 'active');
      drawerEl.removeAttribute('aria-hidden');
      dialog?.removeAttribute('aria-hidden');
      document.body.classList.add('overflow-hidden');
      const overlay = document.getElementById('CartDrawer-Overlay')
                   ?? document.querySelector('.cart-drawer__overlay');
      if (overlay) { overlay.classList.remove('hidden'); overlay.style.display = 'block'; }
    }
  }


  function _showQtyBox(wrapper, qty) {
    const btn    = wrapper.querySelector('[data-atc-btn]');
    const qtyBox = wrapper.querySelector('[data-atc-qty-box]');
    const count  = wrapper.querySelector('[data-qty-count]');
    btn?.classList.add('hidden');
    qtyBox?.classList.remove('hidden');
    if (count) count.textContent = qty;
  }

  function _showAtcBtn(wrapper) {
    const btn    = wrapper.querySelector('[data-atc-btn]');
    const qtyBox = wrapper.querySelector('[data-atc-qty-box]');
    qtyBox?.classList.add('hidden');
    btn?.classList.remove('hidden');
    if (btn) btn.disabled = false;
  }

  function _setLoading(wrapper, on) {
    const minus = wrapper.querySelector('[data-action="minus"]');
    const plus  = wrapper.querySelector('[data-action="plus"]');
    const btn   = wrapper.querySelector('[data-atc-btn]');
    minus?.classList.toggle('loading', on);
    plus?.classList.toggle('loading', on);
    if (btn) btn.disabled = on;
  }

  function _getQty(wrapper) {
    return parseInt(wrapper.querySelector('[data-qty-count]')?.textContent, 10) || 0;
  }


  async function initWrapper(wrapper) {
    if (wrapper.dataset.bbInit) return;
    wrapper.dataset.bbInit = '1';

    const variantId = String(wrapper.dataset.variantId || '');
    if (!variantId) return;

    


    try {
      const cart = await _getCart();
      const item = cart.items.find(i => String(i.variant_id) === variantId);
      if (item && item.quantity > 0) _showQtyBox(wrapper, item.quantity);
    } catch(_) {}

    const atcBtn = wrapper.querySelector('[data-atc-btn]');
    atcBtn?.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      _setLoading(wrapper, true);
      _showQtyBox(wrapper, 1);        // ← OPTIMISTIC: turant dikhao
      try {
        await _cartAdd(variantId, 1);
        await _refreshDrawer(); await _openDrawer();
        const cart = await _getCart();
        const item = cart.items.find(i => String(i.variant_id) === variantId);
        _showQtyBox(wrapper, item ? item.quantity : 1);
      } catch(err) {
        console.error('[buy-btn] add failed', err);
        _showAtcBtn(wrapper);
      } finally {
        _setLoading(wrapper, false);
      }
    });

    wrapper.querySelector('[data-action="plus"]')?.addEventListener('click', async () => {
      const current = _getQty(wrapper);
      _setLoading(wrapper, true);
      const newQty  = current + 1;
      const countEl = wrapper.querySelector('[data-qty-count]');
      if (countEl) countEl.textContent = newQty; // ← OPTIMISTIC
      try {
        const cart = await _getCart();
        const item = cart.items.find(i => String(i.variant_id) === variantId);
        if (!item) await _cartAdd(variantId, newQty);
        else       await _cartChange(item.key, newQty);
        await _refreshDrawer(); await _openDrawer();
        const updatedCart = await _getCart();
        const updatedItem = updatedCart.items.find(i => String(i.variant_id) === variantId);
        if (countEl) countEl.textContent = updatedItem ? updatedItem.quantity : newQty;
      } catch(err) {
        console.error('[buy-btn] plus failed', err);
        if (countEl) countEl.textContent = current;
      } finally {
        _setLoading(wrapper, false);
      }
    });

    wrapper.querySelector('[data-action="minus"]')?.addEventListener('click', async () => {
      const current = _getQty(wrapper);
      if (current <= 0) return;
      _setLoading(wrapper, true);
      const newQty  = current - 1;
      const countEl = wrapper.querySelector('[data-qty-count]');

      if (newQty > 0) {
        if (countEl) countEl.textContent = newQty; // ← OPTIMISTIC
      } else {
        _showAtcBtn(wrapper);
      }

      try {
        const cart = await _getCart();
        const item = cart.items.find(i => String(i.variant_id) === variantId);
        if (item) await _cartChange(item.key, newQty);

        if (newQty <= 0) {
          await _refreshDrawer();
          _showAtcBtn(wrapper);
        } else {
          await _refreshDrawer(); await _openDrawer();
          const updatedCart = await _getCart();
          const updatedItem = updatedCart.items.find(i => String(i.variant_id) === variantId);
          const confirmedQty = updatedItem ? updatedItem.quantity : 0;
          if (confirmedQty <= 0) _showAtcBtn(wrapper);
          else if (countEl) countEl.textContent = confirmedQty;
        }
      } catch(err) {
        console.error('[buy-btn] minus failed', err);
        if (current > 0) _showQtyBox(wrapper, current);
      } finally {
        _setLoading(wrapper, false);
      }
    });
  }

  function _observeRecommendations() {
    document.querySelectorAll('product-recommendations').forEach(el => {
      if (el.dataset.bbObserved) return;
      el.dataset.bbObserved = '1';

      new MutationObserver(() => {
        el.querySelectorAll('.atc-qty-wrapper:not([data-bb-init])').forEach(initWrapper);
        _attachDrawerObserver();
      }).observe(el, { childList: true, subtree: true });
    });
  }


 function boot() {
  document.querySelectorAll('.atc-qty-wrapper').forEach(initWrapper);
  _attachDrawerObserver();
  _observeRecommendations(); 
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

})();


document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('button, a.button, input[type="submit"], [role="button"]')
    .forEach(function (btn) {

      const text = (btn.textContent || btn.value || '')
        .trim()
        .toLowerCase();

      if (text === 'sold out') {
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.5';
      }
    });
});